import axios from "axios";
import url from "../config/urlServiceConfig";

const strategyAPI = {
  getAll: () => axios.get(url.strategy),
  getById: (id) => axios.get(`${url.strategy}/${id}`),
  create: (body) => axios.post(url.strategy, body),
  update: (body) => axios.put(url.strategy, body),
  delete: (id) => axios.delete(`${url.strategy}/${id}`),
  getAllStrategyByType: (params) => axios.get(`StrategyByType`, { params }),
  getAllWithThemes: () => axios.get(`${url.strategy}/Themes`),
  getAllWithPerspectives: () => axios.get(`${url.strategy}/Perspectives`),
  getAllWithPillars: () => axios.get(`${url.strategy}/Pillars`),
  getAllWithObjectives: (params) =>
    axios.get(`${url.strategy}/Objectives`, { params }),
  getStrategiesWithObjectives: (params) =>
    axios.get(`${url.strategy}/ObjectivesList`, { params }),
  getAllWithKPIs: () => axios.get(`${url.strategy}/KPI`),
  getAllWithOrgStructures: (params) =>
    axios.get(`${url.strategy}/OrgStructures`, { params }),
  validateMainStrategy: (id) =>
    axios.get(`${url.strategy}/ValidateMainStrategy/${id}`)
};

export default strategyAPI;
